export const statusVariant = {
  paymentPending: 'Pending',
  paymentComplete: 'Accepted',
  canceled: 'Rejected'
} as const;

